const isWeChatMiniProgram = false;
const isWeb = true;
const isMRN = false;
import { getRiskParams } from '@nibfe/mkt-risk-api';
import { RiskOperateSource, RiskPlatform } from '../types/domain';
import { stringToFloat } from './number';
export function getRiskOperateSource() {
    if (true) {
        return RiskOperateSource.H5;
    }
    return RiskOperateSource.H5;
}
export async function getRiskRequest(commonParams) {
    let result = {
        operateSource: getRiskOperateSource(),
        platform: RiskPlatform.IOS,
        uuid: '',
        fingerprint: '',
        version: '',
        appid: '',
        openid: '',
        expoId: '',
        h5_fingerprint: '',
        app: undefined,
        latitude: stringToFloat(commonParams?.lat),
        longitude: stringToFloat(commonParams?.lng)
    };
    try {
        const riskParams = await getRiskParams(/** 风险标识-酒店 */ 2);
        result = {
            ...result,
            ...riskParams
        };
        return result;
    }
    catch (e) {
        return result;
    }
}
